'use strict';
import api from 'utils/api';
import Immutable from 'immutable';
import flatten from 'lodash/array/flatten';

const ShareSource = (alt) => {
    return {
        loadShare: {
            remote(state, shareId) {
                return api.get('basket/share/' + shareId);
            },
            success: alt.getActions('share').loadShareSuccess,
            error: alt.getActions('share').loadError
        },
        requestAccess: {
            remote(state, data) {
                return api.post('request_access', data).then( () => {
                    return { success: true, media_id: data.media_id };
                });
            },
            success: alt.getActions('share').requestAccessSuccess,
            error: alt.getActions('share').requestAccessError
        },
        download: {
            remote(state, data) {
                return api.post('download', data);
            },
            success: alt.getActions('share').downloadSuccess,
            error: alt.getActions('share').downloadError
        }
    };
};

export default class ShareStore {

    constructor() {
        this.bindActions(this.alt.getActions('share'));
        this.registerAsync(ShareSource);

        this.baskets = Immutable.fromJS([]);
        this.user = Immutable.fromJS({});
    }

    onLoadShareSuccess(data) {
        data.baskets = data.baskets.map( basket => {
            basket.items = basket.items.map( item => {
                item.tags = [];
                return item;
            });
            return basket;
        });

        this.baskets = Immutable.fromJS(data.baskets);

        this.user = Immutable.fromJS({
            email: data.email,
            firstName: data.firstName
        });
    }

    onloadError(err) {
        console.warn('onloadError', err);
    }

    onToggleItemSelection(data) {
        var bix = this.baskets.findIndex( basket => basket.get('id') === data.basketId );
        this.baskets = this.baskets.updateIn([bix, 'items'], items => {
            var ix = items.findIndex( item => item.get('id') === data.itemId );
            return items.updateIn([ix, '_checked'], checked => !checked ).updateIn([ix, 'files'], files => {
                if(!data.fileKey) return files;
                var fileIx = files.findIndex((file) => file.get('key') === data.fileKey);
                return files.updateIn([fileIx], (sfile) => {
                    return sfile.set('_download', !sfile.get('_download'));
                });
            });
        })
    }

    onToggleAllItems(data) {
        var bix = this.baskets.findIndex( basket => basket.get('id') === data.basketId );
        this.baskets = this.baskets.updateIn([bix, 'items'], items => items.map( item => {
            if ( item.get('visible') ) {
                return item.update('_checked', checked => data.checkAll);
            }
            else {
                return item;
            }
        }));
    }

    onToggleDownloadAll(data) {
        var bix = this.baskets.findIndex( basket => basket.get('id') === data.basketId );
        this.baskets = this.baskets.updateIn([bix, 'items'], items => items.map( item => {
            if ( item.get('visible') ) {
                return item.update('files', files => files.map( file => {
                    if(file.get('key') === data.fileKey) return file.update('_download', download => data.shouldCheckAll);
                    return file;
                }));
            }
            else {
                return item;
            }
        }));
    }

    onDownloadSuccess( result ) {
        // console.log('on download success', result);
    }

    onDownloadError( error ) {
        // console.log('on download error', error);
    }

    onRequestAccessSuccess(result) {
        this.baskets = Immutable.fromJS( this.baskets.toJSON().map( basket => {
            basket.items = basket.items.map( item => {
                if ( result.media_id === item.id ) {
                    item.access_requested = true;
                }
                return item;
            });
            return basket;
        }));
    }

    onRequestAccessError(result) {

    }

    static getItemsToDownload(items) {
        return flatten(items.map((item) => {
            var itemId = item.id;
            return item.files.filter((file) => file._download).map((file) => {
                return {id: itemId, size: file.key};
            });
        }));
    }
}



// WEBPACK FOOTER //
// ./app/stores/shareStore.js